var map = {
	"./crop": 6120,
	"./crop.tsx": 6120,
	"./field": 1324,
	"./field.tsx": 1324,
	"./location": 7215,
	"./location.tsx": 7215,
	"./planting": 4627,
	"./planting.tsx": 4627,
	"./prolongedPlanting": 5413,
	"./prolongedPlanting.tsx": 5413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7732;